import {UserClaims, UserTypeClaimKey} from 'Users/models/Claims';
import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {OpportunitySummary} from './components/Opportunity/OpportunitySummary';
import {CreateProposalForm} from './components/Proposal/CreateProposal';
import {CreateQuoteForm} from './components/QuoteForm/Quoting';
import {GenerateProposalPage} from './components/Proposal/GenerateProposalPage';
import QuotingPage from './components/QuotingPage';

export type QuotingRoutesProps = {
  claims: UserClaims;
};

export const QuotingRouteConstants = {
  QUOTING_ROOT: '/quoting',

  OPPORTUNITY_SEARCH: () => `${QuotingRouteConstants.QUOTING_ROOT}/search`,

  OPPORTUNITY_SUMMARY: (opportunityId: string) => `${QuotingRouteConstants.QUOTING_ROOT}/opportunity/${opportunityId}`,
  CREATE_QUOTE: (modelName: string, rootId: string, revisionNo: string) =>
    `${QuotingRouteConstants.QUOTING_ROOT}/quote/${modelName}/${rootId}/${revisionNo}/edit`,

  CREATE_PROPOSAL: (opportunityId: string) => `${QuotingRouteConstants.QUOTING_ROOT}/${opportunityId}/create-proposal`,
  GENERATE_PROPOSAL: (
    opportunityNumber: string,
    customerNumber: string,
    proposalRootId: string,
    proposalRevisionNo: string
  ) =>
    `${QuotingRouteConstants.QUOTING_ROOT}/${opportunityNumber}/${customerNumber}/${proposalRootId}/${proposalRevisionNo}`,
};

const QuotingRoutes = ({claims}: QuotingRoutesProps) => {
  const hasQuotingAccess = claims.userTypes.some(ut => ut.$type === UserTypeClaimKey.Quoting);

  return (
    <Route
      path={'/quoting'}
      render={routeProps =>
        hasQuotingAccess ? (
          <Switch>
            <Route
              exact
              path={QuotingRouteConstants.QUOTING_ROOT}
              render={() => <QuotingPage />}
            />
            <Route
              exact
              path={QuotingRouteConstants.OPPORTUNITY_SEARCH()}
              render={() => <QuotingPage />}
            />
            <Route
              exact
              path={QuotingRouteConstants.OPPORTUNITY_SUMMARY(':opportunityId')}
              render={() => <OpportunitySummary />}
            />
            <Route
              exact
              path={QuotingRouteConstants.CREATE_QUOTE(':modelName', ':quoteId', ':revisionNo')}
              render={() => <CreateQuoteForm {...routeProps} />}
            />
            <Route
              exact
              path={QuotingRouteConstants.CREATE_PROPOSAL(':opportunityId')}
              render={() => <CreateProposalForm />}
            />
            <Route
              exact
              path={QuotingRouteConstants.GENERATE_PROPOSAL(
                ':opportunityNumber',
                ':customerNumber',
                ':proposalRootId',
                ':proposalRevisionNo'
              )}
              render={() => <GenerateProposalPage />}
            />
          </Switch>
        ) : (
          <Redirect to="/unauthorized" />
        )
      }
    />
  );
};

export default QuotingRoutes;
